module.exports = __webpack_public_path__ + "static/media/sf-test-19.dd67eedc.mp3";